export const ArrowRightIcon = ({ className }: { className?: string }) => (
    <svg
        className={className || ''}
        width="6"
        height="10"
        viewBox="0 0 6 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.71837 5.01278C5.71837 4.84534 5.63477 4.6779 5.55117 4.59418L1.37118 0.408129C1.12039 0.156966 0.702387 0.156966 0.451588 0.408129C0.200789 0.659292 0.200789 1.0779 0.451588 1.32906L4.21357 5.0965L0.451588 8.86394C0.200789 9.11511 0.200789 9.53371 0.451588 9.78487C0.702387 10.036 1.12039 10.036 1.37118 9.78487L5.55117 5.59883C5.63477 5.26394 5.71837 5.0965 5.71837 5.01278Z"
            fill="#333333"
        />
    </svg>
);
